import { render } from "./PatientNotListedCard.vue?vue&type=template&id=472106ed&scoped=true"
import script from "./PatientNotListedCard.vue?vue&type=script&lang=js"
export * from "./PatientNotListedCard.vue?vue&type=script&lang=js"

import "./PatientNotListedCard.vue?vue&type=style&index=0&id=472106ed&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472106ed"]])

export default __exports__